import produce from 'immer';
import { actionTypes as dateRangePickerActionTypes, reducerValuesFunction as dateRangePickerReducerFunction } from '@components/Kendo/DateRangePickerReducer';
export const actionTypes = Object.assign({ PAGE_CHANGED: 'PAGE_CHANGED', SORT_CHANGED: 'SORT_CHANGED', FILTER_CHANGED: 'FILTER_CHANGED', FILTER_TOGGLED: 'FILTER_TOGGLED', LOADING_CHANGED: 'LOADING_CHANGED', DATA_LOADED: 'DATA_LOADED', SEARCH_CHANGED: 'SEARCH_CHANGED', COLUMNS_CHANGED: 'COLUMNS_CHANGED' }, dateRangePickerActionTypes // static line, should be the only one for all DateRangePickers
);
export const reducer = (state, action) => {
    return produce(state, (draft) => {
        // static snippet, should be the only one for all DateRangePickers
        if (Object.keys(dateRangePickerActionTypes).includes(action.type)) {
            dateRangePickerReducerFunction(draft, action);
            draft.page.skip = 0;
            return;
        }
        switch (action.type) {
            case actionTypes.LOADING_CHANGED:
                draft.loading = action.loading;
                break;
            case actionTypes.SEARCH_CHANGED:
                draft.search = action.search;
                draft.page.skip = 0;
                break;
            case actionTypes.DATA_LOADED:
                draft.data = action.data.data;
                draft.totalCount = action.data.totalCount;
                break;
            case actionTypes.PAGE_CHANGED:
                draft.page = action.page;
                break;
            case actionTypes.SORT_CHANGED:
                draft.sort = action.sort;
                break;
            case actionTypes.FILTER_CHANGED:
                if (action.filters) {
                    draft.page.skip = 0;
                    draft.filters = action.filters;
                }
                else if (action.field) {
                    draft.page.skip = 0;
                    draft.filters.values[action.field] = action.value;
                }
                break;
            case actionTypes.FILTER_TOGGLED:
                if (action.field) {
                    draft.filters.active[action.field] =
                        !draft.filters.active[action.field];
                }
                break;
            case actionTypes.COLUMNS_CHANGED:
                if (action.columns) {
                    draft.columns = action.columns;
                }
                break;
        }
    });
};
